import ModalCrudUser from '../../components/ModalCrudUser.vue';
import Vue from 'vue';
const modalCrudUser = (editMode, requireMassive, onlyDrivers, user, groups, callback) => {
  const vm = new Vue({
    ...ModalCrudUser,
    propsData: { editMode, requireMassive, onlyDrivers, user, groups, callback },
  });
  vm.$mount();
  vm.$bvModal.show('crud-user-modal');
};
export default modalCrudUser;
